import { motion } from "framer-motion";
import { Instagram, ArrowUpRight } from "lucide-react";
import { RevealText } from "./RevealText";
import { SOCIALS } from "../../lib/landing";

const XIcon = ({ size = 26 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const Socials = () => {
  return (
    <section
      id="social"
      data-testid="socials-section"
      className="relative py-28 sm:py-36 bg-brand-surface"
    >
      <div className="mx-auto max-w-[1400px] px-4 sm:px-8">
        <div className="max-w-2xl mb-14">
          <span className="text-xs uppercase tracking-[0.25em] text-brand-primary">
            Unisciti al movimento
          </span>
          <h2 className="mt-6 font-display font-medium tracking-tight leading-[0.95] text-brand-text text-4xl sm:text-5xl md:text-6xl">
            <RevealText inView lines={["Seguici. Diffondi.", "Fai la differenza."]} />
          </h2>
          <p className="mt-6 text-brand-muted text-base md:text-lg leading-relaxed">
            Due voci, un solo obiettivo. Scegli il canale che parla la tua
            lingua e resta parte della community.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* Instagram */}
          <motion.a
            href={SOCIALS.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="instagram-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ scale: 0.99 }}
            className="group relative overflow-hidden rounded-3xl bg-brand-bg border border-brand-line p-8 sm:p-10 min-h-[340px] flex flex-col justify-between"
          >
            <div className="flex items-start justify-between">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-primary/10 text-brand-primary">
                <Instagram size={26} />
              </div>
              <ArrowUpRight
                size={28}
                className="text-brand-muted transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-brand-primary"
              />
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-brand-muted">
                @safherofficial
              </p>
              <h3 className="mt-3 font-display text-3xl sm:text-4xl text-brand-text tracking-tight">
                Instagram
              </h3>
              <p className="mt-4 text-brand-muted leading-relaxed max-w-md">
                Contenuti di sensibilizzazione sulla violenza di genere, storie,
                risorse e campagne per creare consapevolezza.
              </p>
            </div>
          </motion.a>

          {/* X */}
          <motion.a
            href={SOCIALS.x}
            target="_blank"
            rel="noreferrer"
            data-testid="x-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.7, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ scale: 0.99 }}
            className="group relative overflow-hidden rounded-3xl bg-brand-dark border border-brand-dark p-8 sm:p-10 min-h-[340px] flex flex-col justify-between"
          >
            <div className="flex items-start justify-between">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-inverse/10 text-brand-inverse">
                <XIcon size={24} />
              </div>
              <ArrowUpRight
                size={28}
                className="text-brand-inverse/50 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-brand-inverse"
              />
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-brand-inverse/50">
                @safeherapp
              </p>
              <h3 className="mt-3 font-display text-3xl sm:text-4xl text-brand-inverse tracking-tight">
                X / Twitter
              </h3>
              <p className="mt-4 text-brand-inverse/70 leading-relaxed max-w-md">
                Aggiornamenti tecnici, novità sull'app, dati e approfondimenti
                per chi vuole andare a fondo del tema.
              </p>
            </div>
          </motion.a>
        </div>
      </div>
    </section>
  );
};

export default Socials;
